import Vue from "vue";
import Router from "vue-router";
import vueCookie from "vue-cookie"
import _ from 'lodash'
Vue.use(Router);
//comment
// route-level code splitting
const LoginView = () => import("../views/auth/loginView.vue");
const ForgotPassword = () => import("../views/auth/ForgotPassword.vue");
const UpdatePassword = () => import("../views/auth/UpdatePassword.vue");
const ChangePassword = () => import("../views/auth/ChangePassword.vue");
const MainDashboard = () => import("../views/dashboard/MainDashboard.vue");
const CompoView = () => import("../views/allcomps/allcomponents.vue");
const PageNotFound = () => import("../views/common/404.vue");
//  Patient
const PatientListView = () => import("../views/patient/patientListView.vue");
//Employee
const EmployeeView = () => import("../views/employee/employeeView.vue");
//Appointment
const AppointmentView = () => import("../views/appointments/appointmentsView.vue");
//ScheduleView
const ScheduleView = () => import("../views/schedule/scheduleView.vue");
//PharmacyView
const PharmacyView = () => import("../views/pharmacy/pharmacyView.vue");
//ParamedicalView
const ParamedicalView = () => import("../views/paramedical/paramedicalView.vue");
//AccountsView
const AccountsView = () => import("../views/accounts/accountsView.vue");
//RoleManageView
const RoleManageView = () => import("../views/role-manager/roleManageView.vue");
//RoleManageView
const MasterView = () => import("../views/master/masterView.vue");
//SettingsView ervices
const SettingsView = () => import("../views/settings/settingsView.vue");
//ServiceView
const ServiceView = () => import("../views/services/servicesView.vue");
const Reviews = () => import("../views/reviews/Reviews.vue");
const Profileview = () =>import("../views/profile/Myprofile.vue");
const MapView = () => import("../views/MapView.vue");
const Package = () => import("../views/Packages/Packages.vue");
const Coupon = () => import("../views/Coupon/Coupon.vue");
const RateAndReview =()=>import("../views/rateandreview/RateAndReview.vue");
const MultiPatientApt = () => import("../views/multipatientapt/MultiPatientApt.vue")

const router = new Router({
    mode: "history",
    fallback: false,
    scrollBehavior: () => ({
      y: 0
    }),
    routes: [{
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/login",
      component: LoginView,
      name: "login",
      props: true
    },
    {
      path: "/dashboard/:page(\\d+)?",
      component: MainDashboard,
      name: "dashboard",
      meta: {
        auth: true
      }
    },
     {
      path: "*",
      name: "pagenotfound",
      component: PageNotFound
    }, 
    {
      path: "/components/:page(\\d+)?",
      component: CompoView,
      name: "components"
    },
    
    {
      path: "/patients/:action?/:appId?",
      component: PatientListView,
      name: "patients",
      meta: {
        auth: true
      }
    },
    {
      path: "/myprofile/:action?",
      component: Profileview,
      name: "profile",
      meta: {
        auth: true
      }
    },
    {
      path: "/employees/:usertype?/:action?/:employeeId?",
      component: EmployeeView,
      name: "employees",
      meta: {
        auth: true
      }
    },
    {
      path: "/appointments/:action?/:appid?",
      component: AppointmentView,
      name: "appointments",
      meta: {
        auth: true
      }
    },
    /* {
      path: "/schedule/:action?/:empid?",
      component: ScheduleView,
      name: "schedule",
      meta: {
        auth: true
      }
    }, */
    {
      path: "/pharmacy/:usertype?",
      component: PharmacyView,
      name: "pharmacy",
      meta: {
        auth: true
      }
    },
    {
      path: "/paramedical/:usertype?",
      component: ParamedicalView,
      name: "paramediacl",
      meta: {
        auth: true
      }
    },
    {
      path: "/accounts/:action?/:appid?",
      component: AccountsView,
      name: "accounts",
      meta: {
        auth: true
      }
    },
    {
      path: "/role-manager/:action?/:roleid?",
      component: RoleManageView,
      name: "role-manager",
      meta: {
        auth: true
      }
    },
    {
      path: "/services/:servicetype?/:action?/:serviceid?",
      component: ServiceView,
      name: "services",
      meta: {
        auth: true
      }
    },
    {
      path: "/master/:mastertype?/:action?/:emptype?",
      component: MasterView,
      name: "master",
      meta: {
        auth: true
      }
    },
    {
      path: "/settings/:action?/:page?",
      component: SettingsView,
      name: "settings",
      meta: {
        auth: true
      }
    },
    {
      path: "/rateandreview/:action?/:appid?",
      component: RateAndReview,
      name: "rateandreview",
      meta: {
        auth: true
      }
    },
    { path: "/package/:action?/:id?",
      component: Package,
       name: "Package",
        meta:{auth:true} },
    {
      path: "/forgot-password",
      component: ForgotPassword,
      name: "forgot-password",
      meta: {
        auth: true
      }
    },
    {
      path: "/set-password",
      component: UpdatePassword,
      name: "set-password"
    },
    { path: "/reviews/:action?/:page?", component: Reviews, name: "Reviews", meta:{auth:true} },
    {
      path: "/change-password",
      component: ChangePassword,
      name: "change-password"
    },
    { path: "/mapview",  component: MapView, name: "mapview", props: true },
    { path: "/coupon/:action?/:id?", component: Coupon, name: "Coupon", meta:{auth:true} },
    { path: "/multi-patient/:action?/:appid?", component: MultiPatientApt, name: "MultiPatientApt", meta:{auth:true} },

    ]
  });
  router.beforeResolve((to, from, next) => {
    if(from.name && from.name.toLocaleLowerCase()!="rateandreview"){
      localStorage.setItem('pageNumber','1')
      localStorage.setItem('RateandReview','Rating')
     }
    let token = vueCookie.get('token')
    if(token){
      let status = true;
      router.app.$store.dispatch('auth/UPDATE_LOGIN',{status, token})
    }else{
      let status = false;
      router.app.$store.dispatch('auth/UPDATE_LOGIN',{status, token})
    }
    if (router.app.$store) {
      const isAuthRequired = to.meta.auth;
      let _token = router.app.$store.getters['auth/getToken'];
      if (isAuthRequired && !_token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          if (to.name == 'forgot-password') {
            return next({
              name: 'forgot-password'
            })
          }
          else if (to.name == 'set-password') {
            return next({
              name: 'set-password'
            })
          }
          else {
            return next({
              name: 'login'
            })
          }

        }, 100)
      }
      if (to.name === 'login' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      } if (to.name === 'forgot-password' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      }
      if (to.name === 'set-password' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      }
      else {
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next()
      }

    }
    router.app.$store.dispatch("SET_LAYOUT", to.name);
    return next()
  });
  export default router;



// WEBPACK FOOTER //
// ./src/router/index.js